import React, {useState} from "react";
import {OptionOIS} from "../module";
import {Contractor} from "../Interfaces/IDOOP";
import {isUserroleSufficient} from "../../../Utils/authorization";
import {UserRoles} from "../../../Utils";
import {HubPathRouting} from "../../../HubFramework/pathBuilder";
import EditProjectModal from './EditProjectModal';
import OdxAreaHeader from "../../../OdxComponents/NativeOdx/Odx-AreaHeader";
import OdxTable from "../../../OdxComponents/NativeOdx/Table/Odx-Table";
import {OdxTableRow} from "../../../OdxComponents/NativeOdx/Table/Odx-TableRow";
import {OdxTableCell} from "../../../OdxComponents/NativeOdx/Table/Odx-Tablecell";
import {odxIconSets} from "../../../OdxComponents/constants";
import OdxBreadcrumbs from "../../../OdxComponents/NativeOdx/Odx-Breadcrumbs";
import {convertListOfStringsToOptionsList} from "../../../Utils/transformer";
import {useDoopData} from "../doopDataContext";

const Configuration: React.FC = () => {
    const [popup, setPopup] = useState(false);
    const [Name, setName] = useState("");
    const [Value, setValue] = useState<string | string[] | boolean>("");
    const [Areas, setAreas] = useState<OptionOIS[]>([]);
    const [Contractors, setContractors] = useState<Contractor[]>([]);
    const {meta, error} = useDoopData();

    const EditProjectShow = (name: string, value: string | string[] | boolean | Contractor[]) => {
        switch (name) {
            case "doopAreas":
                setAreas(convertListOfStringsToOptionsList(value as string[]));
                setValue(value as string[]);
                break;
            case "contractors":
                setContractors(value as Contractor[]);
                setValue("");
                break;
            default:
                setValue(value as string | string[] | boolean);
                break;
        }
        setPopup(true);
        setName(name);
    };


    const evaluateDisplayedValue = (value: string | string[] | boolean | Contractor[]) => {
        if (value === undefined)
            return <div></div>;
        if (Array.isArray(value)) {
            if (value.length > 0) {
                switch (typeof value[0]) {
                    case "string":
                        return <div>{value.join(", ")}</div>;
                    default:
                        return <div>{(value as Contractor[]).map((v) => v.Name).join(", ")}</div>;
                }
            }
        }
        let strValue = value.toString();
        if (strValue[0] === '[' && strValue[strValue.length - 1] === ']') {
            let val = JSON.parse(strValue);
            return <div>{val.join(', ')}</div>;
        } else if (strValue === "true") {
            return <div className="text-green-500">Yes</div>;
        } else if (strValue === "false") {
            return <div className="text-red-500">No</div>;
        } else {
            return <div>{strValue}</div>;
        }
    };

    if (error) {
        return <div>{error}</div>;
    }

    if (meta === null) {
        return <div></div>;
    }

    const tableData = [
        ...Object.keys(meta).filter(k => ['name', 'doopAreas', 'contractors', 'defaultPriceModel', 'defaultOrderNumber' /* other keys to display */].includes(k)).map(k => ({
            key: k,
            value: meta[k],
            edit: k
        }))
    ];

    return (
        <>
            <OdxBreadcrumbs/>
            {popup && (
                <EditProjectModal
                    name={Name}
                    value={Value}
                    contractors={Contractors}
                    closePopup={() => setPopup(false)}
                />
            )}
            <div className="p-4">
                <OdxAreaHeader
                    text="Configuration"
                    odxSize="medium"
                    className={'!pl-0 !pr-0'}
                />
                <div className="mt-4">
                    <OdxTable
                        id={"Doop_Config_Table"}
                        headerData={[
                            {name: 'key', title: 'Key'},
                            {name: 'value', title: 'Value'},
                            {name: '', title: '', required: true},

                            isUserroleSufficient(UserRoles.editor, HubPathRouting.currentProject?.id, HubPathRouting.currentModule?.id) && {
                                name: 'edit',
                                title: 'Edit'
                            }
                        ].filter(Boolean)}
                    >
                        {tableData.map((row, index) => (
                            <OdxTableRow key={index} id={"Doop_Config_Row_" + row.key}>
                                <OdxTableCell>{row.key}</OdxTableCell>
                                <OdxTableCell>{evaluateDisplayedValue(row.value)}</OdxTableCell>
                                {isUserroleSufficient(UserRoles.editor, HubPathRouting.currentProject?.id, HubPathRouting.currentModule?.id) && (
                                    <OdxTableCell className="text-center">
                                        <odx-icon-button
                                            id={`Doop_Config_EditBtn_${row.key}`}
                                            variant="ghost"
                                            icon={`${odxIconSets.core}::chevron-right`}
                                            onClick={() => EditProjectShow(row.key, row.value)}
                                        />
                                    </OdxTableCell>
                                )}
                            </OdxTableRow>
                        ))}
                    </OdxTable>
                </div>
            </div>
        </>
    );
};

export default Configuration;
